// extracted by mini-css-extract-plugin
export default {"root":"Gift_root__fHe0Z","message":"Gift_message__9rUaq","icon":"Gift_icon__QYG3c"};